import { render, staticRenderFns } from "./ScenarioSelection.vue?vue&type=template&id=33d0ff7c&scoped=true"
import script from "./ScenarioSelection.vue?vue&type=script&lang=js"
export * from "./ScenarioSelection.vue?vue&type=script&lang=js"
import style0 from "./ScenarioSelection.vue?vue&type=style&index=0&id=33d0ff7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d0ff7c",
  null
  
)

export default component.exports